import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACES.REGULAR.FAMILY};
    src: url(${({ theme }) => theme.FONT_FACES.REGULAR.SRC})
    format('${({ theme }) => theme.FONT_FACES.REGULAR.FORMAT}')
  }

  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACES.LIGHT.FAMILY};
    src: url(${({ theme }) => theme.FONT_FACES.LIGHT.SRC})
    format('${({ theme }) => theme.FONT_FACES.LIGHT.FORMAT}')
  }

  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACES.SEMI_BOLD.FAMILY};
    src: url(${({ theme }) => theme.FONT_FACES.SEMI_BOLD.SRC})
    format('${({ theme }) => theme.FONT_FACES.SEMI_BOLD.FORMAT}')
  }

  html {
    height: 100%;
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    margin: ${({ theme }) => theme.BODY_MARGIN};
    background: ${({ theme }) => theme.COLORS.NEUTRAL};
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
    -webkit-font-smoothing: antialiased;
  }

  #root, main {
    height: 100%;
  }

  ul {
    padding-left: 0;
    margin: 0;

    li {
      list-style: none;
    }
  }

  h1, h2 {
    font-weight: unset;
  }

  h2 {
    font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
    line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
    margin: 0;
  }

  a {
    color: ${({ theme }) => theme.COLORS.TERTIARY};
    text-decoration: none;

    &:visited {
      color: ${({ theme }) => theme.COLORS.TERTIARY};
    }
  }

  input, textarea {
    font-family: ${({ theme }) => theme.FONT.REGULAR};
  }

  .disabledLink {
    pointer-events: none;
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;

export default GlobalStyle;
